import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseStatusPage`

export default defineMessages({
  statusPageTitle: {
    id: `${scope}.statusPageTitle`,
    defaultMessage: 'Expense reports',
  },
  approvalPageTitle: {
    id: `${scope}.approvalPageTitle`,
    defaultMessage: 'Expense approval',
  },
})
